import SelectCustomizable, { utilsSelectCustomizable } from '__core/modules/atoms/SelectCustomizable';
import { educationLevels } from 'app/store/index';
import { orderWithAccents } from 'app/utils/array';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const SelectDisciplines = React.forwardRef(function (
  { countries, country, disabled = false, isMulti = true, isSkeleton, menuPosition = 'initial', name, onBlur, onChange = () => null, required, value },
  ref
) {
  const { t } = useTranslation(['common']);
  const disciplines = useSelector((state) => educationLevels.selectors.getDisciplines(state));
  const disciplinesFilter = getDataFilter();
  const options = utilsSelectCustomizable.getOptionsProperties(disciplinesFilter, 'discipline', 'guid');
  const optionsOrder = getList(options);

  function onChangeSelect(event) {
    onChange(event || []);
  }

  function getList(data) {
    return orderWithAccents(data, 'label');
  }

  function getDataFilter() {
    if (countries) {
      return disciplines.filter((item) => countries.find((element) => element.value === item.country_guid));
    }

    if (country && country.value) {
      return disciplines.filter((item) => item.country_guid === country.value);
    }

    return disciplines;
  }

  return (
    <SelectCustomizable
      isDisabled={disabled}
      isMulti={isMulti}
      isSkeleton={isSkeleton}
      label={t('Subjects')}
      menuPosition={menuPosition}
      name={name}
      onBlur={onBlur}
      onChange={onChangeSelect}
      options={optionsOrder}
      required={required}
      value={value}
    />
  );
});

SelectDisciplines.propTypes = {
  countries: PropTypes.array,
  country: PropTypes.object,
  disabled: PropTypes.bool,
  isMulti: PropTypes.bool,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
};

export default SelectDisciplines;
